import { redirectToLogin } from "../annoucement-sheet";
import { api } from "../api";
import authHeader from "../auth-header";
export interface IServicePageInfoData {
    "service_page": IServiceDataInfo,
    "page_service_section":any;
}
export interface IServiceDataInfo {
    "id": number,
    "sub_menu_id": number,
    "menu_id": number,
    "slug": string,
    "title_en": string,
    "title_tc": string,
    "title_sc": string,
    "meta_title_en": string,
    "meta_title_tc": string,
    "meta_title_sc": string,
    "meta_description_en": string,
    "meta_description_tc": string,
    "meta_description_sc": string,
    "meta_image": string,
    "banner_mobile_image": string,
    "banner_desktop_image": string,
}

export type TData = {
    data: [];
    total: number;
};
export type PaginationData = {
    page: number;
    limit: number | string | undefined;
    search: string | number;
    sort?: string;
    type?: string;
};
export const serviceApi = api.injectEndpoints({
    endpoints: (build) => ({
        getServices: build.query<IServicePageInfoData, string>({
            query: (page_type) => ({
                url: `fetch-service-page?page_type=${page_type}`,
                headers: authHeader()
            }),
            keepUnusedDataFor: 0,
            transformErrorResponse: (err) => {
                if (err?.status === 401) {
                    redirectToLogin();
                }
            },
            providesTags: () => [{ type: "Services" as const, id: "LIST" }]
        }),
        getServicesList: build.query<TData, PaginationData>({
            query: ({ limit, page, search,type,sort}) => ({
                url: `service-content?per_page=${limit}&page=${page}&search=${search}&type=${type}&sort=${sort}`,
                headers: authHeader()
            }),
            keepUnusedDataFor: 0,
            transformErrorResponse: (err) => {
                if (err?.status === 401) {
                    redirectToLogin();
                }
            },
            providesTags: () => [{ type: "Services" as const, id: "LIST" }]
        }),
        getServiceInfo: build.mutation<TData, PaginationData>({
            query({ limit, page, search, type }) {
                return {
                    headers: authHeader(),
                    url: `service-content?type=${type}&per_page=${limit}&page=${page}&search=${search}`,
                    method: "GET",
                };
            },
            invalidatesTags: ['Services']
        }),
        deleteService: build.mutation<TData, number>({
            query(body) {
                return {
                    headers: authHeader(),
                    url: `delete-service-content`,
                    body: {
                        id: body
                    },
                    method: "POST",
                };
            },
            invalidatesTags: ['Services']
        }),
    })
});

export const { useGetServicesQuery,useGetServicesListQuery,useGetServiceInfoMutation,useDeleteServiceMutation } = serviceApi;

export const {
    endpoints: { getServices,getServicesList,getServiceInfo,deleteService }
} = serviceApi;
